module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/remove-db55c6279fb1883e496da8741acd9d84.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/remove.svg
// module id = 4Gj/
// module chunks = 24